import { useRecoilState, useRecoilValue } from "recoil";

import { useConfig } from "./useConfig";
import { walletState } from "../context/walletState";
import { configState } from "../context/configState";
import { useToken } from "./useToken";
import { totalAssetState } from "../context/totalAssetState";
import { useLiquidity } from "./useLiquidity";
import { totalAssetBonded } from "../context/totalAssetBonded";
import { totalAssetPooled } from "../context/totalAssetPooled";

export const useTotalAssetState = () => {
  const { assetsMap, poolsMap } = useRecoilValue(configState);
  let assets = Object.keys(assetsMap);
  let pools = Object.keys(poolsMap);
  const token = useToken();
  const {getPoolUserBonded, getPoolUserAmount} = useLiquidity();

  /*
    Returns total asset dollar value for asset dashboard
  */
  const [totalAsset, setTotalAsset] = useRecoilState(totalAssetState);
  const [totalBonded, setTotalAssetBonded] = useRecoilState(totalAssetBonded);
  const [totalPooled, setTotalAssetpooled] = useRecoilState(totalAssetPooled);
  
  const getTotalAsset = async () => {
    let summm = 0;
    assets.map(async (asset) => {
      const balance = await token.getBalance(assetsMap[asset].display_denom);
      if (Number(balance)) {
        const temp = Number(balance);
        summm = summm + temp;
      }
      setTotalAsset(summm.toFixed(4));
    });
  };

  const getTotalBonded = async () =>{
    let summ = 0;
    pools.map(async (pool) => {
        // const balance = await token.getBalance(assetsMap[asset].display_denom);
        const {userDollarBonded} = await getPoolUserBonded(pool);
        if (Number(userDollarBonded)) {
          const temp = Number(userDollarBonded);
          summ = summ + temp;
          setTotalAssetBonded(summ);
        }
      });
  }

  const getTotalPooled =async () => {
    let summ = 0;
    pools.map(async (pool) => {
        // const balance = await token.getBalance(assetsMap[asset].display_denom);
        const {userAmount} = await getPoolUserAmount(pool);
        if (Number(userAmount)) {
          const temp = Number(userAmount);
          summ = summ + temp;
        }
        setTotalAssetpooled(summ);
      });
  }

  return {
    getTotalAsset,
    getTotalBonded,
    getTotalPooled,
  };
};
